/**
 * 漂流瓶
 * @constructor
 */
export default function DriftBattleConfig() {
    const dataList: DriftBattleEntity[] = [
        // 双色球预知
//         {
//             uniqueId: 1,
//             title: "彩票预支结果",
//             desc: "我是彩票内部工作人员，我绝对不会告诉你的是今天双色球的开奖号码是",
//             days: 0,
//             type: 3,
//             weight: 50,
//             headImgPath : "银行经理",
//             signature : "神秘人",
//             chooseArray: [
//                 {
//                     chooseStr: "确认",
//                     type: 1,
//                     effectNums: 1,
//                     onlyFlag: true,
//                     extraParamsMap: {
//                         "lotteryDays": "0",
//                         "nextTriggerDays": "6"
//                     },
//                 },
//             ]
//         },
//         // 期货预知
//         {
//             uniqueId : 20001,
//             title : "期货预测大师",
//             desc : "各位股民们，我是马老师，我苦练神功，夜观星象，发现最近几年将会进入冰河世纪，世界能源价格将会飞速上涨，今天购买煤炭期货会疯涨三次，看到此消息之后千万不要乱传。不然我就再也不会告诉你们了。",
//             days : 0,
//             type : 6,
//             weight : 400,
//             chooseArray : [
//                 {
//                     chooseStr : "确认",
//                     type : 1,
//                     effectNums : 2,
//                     onlyFlag : true,
//                     extraParamsMap : { "triggerDays" : "1", "nextTriggerDays" :"6"},
//                 },
//             ]
//         },
//         //漂流瓶心情
//         {
//             uniqueId: 3,
//             title: "陌生人的心情",
//             desc: "你可以进二流的公司，但是不能过二流的生活，站起来，去办公室把领导的午饭吃了",
//             days: 15,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扎心了",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 4,
//             title: "陌生人的心情",
//             desc: "没有动态的日子，当然是在漂流瓶发疯了，难不成是在好好生活吗？",
//             days: 16,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 5,
//             title: "陌生人的心情",
//             desc: "哥怎么会emo,哥分手的时候都说6",
//             days: 17,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 6,
//             title: "陌生人的心情",
//             desc: "家里的蟑螂生病了，刚给它喂了蟑螂药，希望它能赶紧好起来",
//             days: 18,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 7,
//             title: "陌生人的心情",
//             desc: "好想把房子卖了去环游世界，可是房东不同意啊",
//             days: 19,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },


//         {
//             uniqueId: 9,
//             title: "陌生人的心情",
//             desc: "你年纪大了还单身，一定存了很多钱吧。",
//             days: 20,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扎心了",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 10,
//             title: "陌生人的心情",
//             desc: "我可太喜欢熬夜了，有种跟阎王单挑的感觉，把闹钟调成唢呐声，醒了就上班，没醒就上路",
//             days: 21,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 11,
//             title: "陌生人的心情",
//             desc: "每日三省吾身：能不能不做，能不能给别人做，能不能明天再做",
//             days: 22,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 12,
//             title: "陌生人的心情",
//             desc: "真心换真心，没想到你是真心不喜欢我啊。",
//             days: 23,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 13,
//             title: "陌生人的心情",
//             desc: "我不回朋友消息：对不起，玩手机没看见。我朋友不回我：这段感情只有我在硬撑。",
//             days: 24,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 3,
//             title: "陌生人的心情",
//             desc: "成功的人：花前月下   一般的人：月下花钱  我：花下月的钱",
//             days: 30,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 14,
//             title: "陌生人的心情",
//             desc: "网恋受过伤，下田插过秧，为爱跳过江，推我几个美女抚平我忧伤。",
//             days: 31,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 15,
//             title: "陌生人的心情",
//             desc: "别人一夸我，我就感觉局促不安，因为我总觉得，他们夸我夸得还不够。",
//             days: 32,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 3,
//             title: "陌生人的心情",
//             desc: "想和你一起在冬天吃火锅，不是冬天也行，不是火锅也行，不是你也行，不是我付钱就行。",
//             days: 33,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 16,
//             title: "陌生人的心情",
//             desc: "我以前也热爱生活，后来上班调理好了",
//             days: 34,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 17,
//             title: "陌生人的心情",
//             desc: "年轻人还是要有自己的想法，不想运动你就不要动，不想恋爱你就不要爱，不想结婚你就不要结，不想上班你就不要想了。",
//             days: 35,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 18,
//             title: "陌生人的心情",
//             desc: "很外向，打车都跟司机抢方向盘，很内向，看见美女不敢直接亲",
//             days: 36,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 19,
//             title: "陌生人的心情",
//             desc: "我不敢收拾自己的房间，我怕只剩下我一个垃圾",
//             days: 37,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 20,
//             title: "陌生人的心情",
//             desc: "你有赚钱的能力，我有花钱的技术，咱两合作，准能干大事！",
//             days: 38,
//             type: 1,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         //剧情特殊事件
//         {
//             uniqueId: 21,
//             title: "乾坤宫左护法",
//             desc: "主人，我联系您很久了，人间的手机俺也不会用，只能扔瓶子联系您，您什么时候回来，您交代我的事情我已经都办妥了，人间现在这么混乱，您确定还要留下来吗。",
//             days: 0,
//             type: 6,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 22,
//             title: "乾坤宫右护法",
//             desc: "主人，圣血麒麟蛋失落人间已久，我已经用力量感知到它的存在了，它离你很近。此去人间，多有凶险，请主人多多保重。",
//             days: 5,
//             type: 6,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 23,
//             title: "乾坤宫大护法",
//             desc: "主人，我等左右护法将在主人获得圣血麒麟蛋时设下宴席在乾坤宫恭迎主人回归！",
//             days: 10,
//             type: 6,
//             weight: 100,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 24,
//             title: "神秘信息",
//             desc: "我被困在湖底几千年了，谁能救救我！啊！！！！！我一定会出来报仇的！！钱布多！！你给我等着！！！",
//             days: 3,
//             type: 6,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },
//         {
//             uniqueId: 25,
//             title: "恋爱邀请卡",
//             desc: "我能想到最浪漫的事，就是和你一起攒钱。快选择你的心上人吧！",
//             days: 0,
//             type: 5,
//             weight: 400,
//             goodsType : 1,
//             goodsImgPath : "shareCard",
//             imgPath:"normal/inviteCard",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "11116": "100",
//                     },
//                 },
//             ]
//         },


//         //3.25新增
//         {
//             uniqueId: 26,
//             title: "探险家",
//             desc: "在村民之间都有传闻说打开蚌壳里面会有各种五颜六色的宝珠，但是我开了好久都没有开出来，到底是哪里出了问题呢？？？是开启时间不对嘛？我就偏不信这个邪了。",
//             days: 1,
//             type: 6,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },

//         {
//             uniqueId: 27,
//             title: "探险家",
//             desc: "我已经来到这个破村子几个月了，想要解开龙蛋的秘密可能还要花掉我不少时间，听村里的长老说召唤神龙蛋就得先集齐雷，火，木，风，海等五颗元素精华。但这只是其中的条件之一。哈哈哈哈哈。而我已经有其中的一颗了。我一定要找到龙蛋！！！",
//             days: 0,
//             type: 6,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },


//         {
//             uniqueId: 28,
//             title: "探险家",
//             desc: "传闻有村民说打开蚌壳里面会有各种五颜六色的宝珠，但是我开了好久都没有开出来，到底是哪里出了问题呢？？？是开启时间不对嘛？还是我的方法不对？不行，我的物资已经不太够了，今天我得再去鸡场偷点鸡蛋维持生活。",
//             days: 0,
//             type: 6,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ]
//         },



// //特殊物品
//         {
//             uniqueId: 100,
//             title: "水草",
//             desc: "你捞起来一堆什么用也没有的水草，拿到集市去卖了吧。",
//             days: 0,
//             type: 5,
//             weight: 80,
//             goodsImgPath : "goods/鞋",
//             imgPath:"clamShell/水草",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10376": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 101,
//             title: "海之精华",
//             desc: "隐隐约约散发出晶莹透亮的光芒，居然是水元素凝结成的海之精华！！！！赶紧收起来！",
//             days: 0,
//             type: 5,
//             weight: 5,
//             imgPath:"clamShell/海之精华",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10391": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 102,
//             title: "夜明珠",
//             desc: "你捞起来一颗闪闪发光的夜明珠！这是召唤凤凰的法宝！！！",
//             days: 0,
//             type: 5,
//             weight: 5,
//             imgPath:"clamShell/夜明珠",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10378": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 103,
//             title: "白色珍珠",
//             desc: "你捞起来一颗珍珠，赶紧收起来吧，卖掉估计能赚一点钱。",
//             days: 0,
//             type: 5,
//             weight: 40,
//             imgPath:"clamShell/白色珍珠",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10370": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 104,
//             title: "神秘物品",
//             desc: "你居然捞起来一个贝壳，里面还睡了一条美人鱼，但是美人鱼趁你不注意逃走了。",
//             days: 0,
//             type: 5,
//             weight: 20,
//             goodsImgPath : "贝壳",
//             imgPath:"clamShell/美人鱼的温床",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10314": "100",
//                     },
//                 },
//             ]
//         },

//         {
//             uniqueId: 105,
//             title: "食用蚌",
//             desc: "你捞起来一个普通河蚌，建议拿去烹饪，或者打开看看是什么吧。",
//             days: 0,
//             type:5,
//             weight: 120,
//             goodsImgPath : "贝壳",
//             imgPath:"clamShell/食用蚌",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "10300": "100",
//                     },
//                 },
//             ]
//         },








//         //食材
//         {
//             uniqueId: 500,
//             title: "冰块",
//             desc: "这大夏天的怎么会出现冰块？",
//             days: 0,
//             type:5,
//             weight: 50,
//             goodsType : 1,
//             goodsImgPath : "ice",
//             imgPath:"goods/ice",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "21200": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 501,
//             title: "柠檬",
//             desc: "谁把这酸掉牙的东西丢湖里的？",
//             days: 0,
//             type:5,
//             weight: 50,
//             goodsType : 1,
//             goodsImgPath : "lemon",
//             imgPath:"goods/lemon",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "21201": "100",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId: 502,
//             title: "龙虾",
//             desc: "哇！这怎么还有那么大的龙虾一定很好吃。",
//             days: 0,
//             type:5,
//             weight: 50,
//             goodsType : 1,
//             goodsImgPath : "lobster",
//             imgPath:"goods/lobster",
//             chooseArray: [
//                 {
//                     chooseStr: "放入背包",
//                     type: 4,
//                     effectNums: 300001,
//                     extraParamsMap: {
//                         "21202": "100",
//                     },
//                 },
//             ]
//         },




// //广告后捞出物品
//         /**
//          imgPath:"clamShell/珍珠兔",
//          imgPath:"clamShell/珍珠羊",
//          imgPath:"clamShell/雷之精华",
//          imgPath:"clamShell/火之精华",
//          imgPath:"clamShell/风之精华",
//          imgPath:"clamShell/木之精华",
//          imgPath:"clamShell/月之宝珠",
//          imgPath:"clamShell/黑翡翠",
//          imgPath:"clamShell/太古灵石",

//          "10379"	:"50",
//          "10380"	:"50",
//          "10381"	:"50",
//          "10382"	:"50",
//          "10383"	:"20",
//          "10384"	:"20",
//          "10385"	:"20",
//          "10386"	:"20",
//          "10387"	:"20",
//          "10388"	:"20",
//          "10389"	:"20",
//          "10390"	:"20",
//          "10391"	:"5",
//          */

//         {
//             uniqueId : 106,
//             title : "心形珍珠",
//             desc : "这是一颗价格不菲的心形珍珠，建议送给女朋友。",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/心形珍珠" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10379"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 107,
//             title : "珍珠兔",
//             desc : "是可爱珍贵的珍珠羊！是12生肖珍珠宝藏之一。集齐12生肖珍珠会获得神秘奖励哦。",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/珍珠兔" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10380"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 108,
//             title : "珍珠羊",
//             desc : "是可爱珍贵的珍珠羊！是12生肖珍珠宝藏之一。集齐12生肖珍珠会获得神秘奖励哦。",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/珍珠羊" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10381"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 109,
//             title : "雷之精华",
//             desc : "居然是蕴含雷电力量的雷之精华，是合成召唤神龙蛋的必要道具！",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/雷之精华" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10383"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 110,
//             title : "火之精华",
//             desc : "是蕴含火焰之力的火之精华，是合成召唤神龙蛋的必要道具！",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/火之精华" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10384"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 111,
//             title : "风之精华",
//             desc : "是蕴含风暴之力的风之精华，是合成召唤神龙蛋的必要道具！",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/风之精华" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10385"	:"50",
//                     },
//                 },
//             ]
//         },

//         {
//             uniqueId : 112,
//             title : "木之精华",
//             desc : "是蕴含山川森林之力的木之精华，是合成召唤神龙蛋的必要道具！",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"clamShell/木之精华" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10386"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 113,
//             title : "月之宝珠",
//             desc : "传说是嫦娥奔月的时候留给后裔的定情信物。能使人移形换影，遁入虚空。",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"ore/月之宝珠" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10388"	:"50",
//                     },
//                 },
//             ]
//         },

//         {
//             uniqueId : 114,
//             title : "黑翡翠",
//             desc : "是价值不菲的黑翡翠，极具收藏价值。建议你放入背包收藏。",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"ore/黑翡翠" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10389"	:"50",
//                     },
//                 },
//             ]
//         },
//         {
//             uniqueId : 115,
//             title : "太古灵石",
//             desc : "居然是蕴藏上古神秘力量的奇迹灵石，赶紧收起来吧！",
//             days : -2,
//             type:5,
//             weight : 100,
//             imgPath:"ore/太古灵石" ,
//             chooseArray : [
//                 {
//                     chooseStr : "收入背包",
//                     type : 4,
//                     effectNums : 300001,
//                     extraParamsMap : {
//                         "10390"	:"50",
//                     },
//                 },
//             ]
//         },









// //支线聊天












//         {//钟灵灵
//             uniqueId: 2001,
//             title: "陌生女孩",
//             desc: "好想恋爱呀。神奇的漂流瓶呀，希望我在这能遇见对的人。",
//             days: 1,
//             type: 2,
//             headImgPath: "钟灵灵",
//             signature: "钟灵灵",
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "联系她",
//                     type: 2,
//                     onlyFlag: true,
//                     effectNums: 29,
//                 },
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },


//         {
//             uniqueId: 2002,
//             title: "网恋滴滴",
//             desc: "美女美女，有没有美女？CPDD，我是纯情大学生，恋爱选我超甜。",
//             days: 1,
//             type: 2,
//             headImgPath: "爸",
//             signature: "老李",
//             weight: 200,
//             chooseArray: [
//                 {
//                     chooseStr: "爸？",
//                     type: 2,
//                     onlyFlag: true,
//                     effectNums: 31,
//                 },
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2003,
//             title: "相亲告示",
//             desc: "我是村里的孙大妈，现在有位小仙女请我帮忙介绍对象，条件优秀。有意者请找我联系，",
//             days: 1,
//             type: 2,
//             headImgPath: "孙大妈",
//             signature: "孙大妈",
//             weight: 200,
//             chooseArray: [
//                 {
//                     chooseStr: "联系",
//                     type: 2,
//                     onlyFlag: true,
//                     effectNums: 32,
//                 },
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2004,
//             title: "变卖传家宝",
//             desc: "我有一个祖传的宝物，价值连城，有意者请带价联系我。谢谢合作。",
//             days: 1,
//             type: 2,
//             headImgPath: "钟叔",
//             signature: "钟叔",
//             weight: 150,
//             chooseArray: [
//                 {
//                     chooseStr: "火速联系",
//                     type: 2,
//                     onlyFlag: true,
//                     effectNums: 33,//钟数卖宝
//                 },
//                 {
//                     chooseStr: "扔回水里",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },



// //与剧情相挂钩的东西   高权重
//         {
//             uniqueId: 2005,
//             title: "孙大妈的担心",
//             desc: "养鸡场那个黑洞邪乎的很啊，千万不要把你养的鸡随便往里面扔，会发出很可怕的声音！上次失手往里面扔了一个小鸡子，差点把我吓晕过去了。",
//             days: 0,
//             type: 2,
//             headImgPath: "孙大妈",
//             signature: "孙大妈",
//             weight: 50,
//             chooseArray: [

//                 {
//                     chooseStr: "好可怕",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2006,
//             title: "钟叔的告诫",
//             desc: "上次弄坏我几十个鱼网，好不容易在池塘捞出一颗夜明珠，结果被突然出现的凤凰给叼走了！！！传说凤凰会用自己的蛋和你交换夜明珠，但是我碰到的这只挺无赖的，不仅不给我凤凰蛋，还把帽子叼走啦！！！！气死我啦！",
//             days: 0,
//             type: 2,
//             headImgPath: "钟叔",
//             signature: "钟叔",
//             weight: 200,
//             chooseArray: [

//                 {
//                     chooseStr: "凤凰？",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },




//         {
//             uniqueId: 2007,
//             title: "乾坤村村委会",
//             desc: "村民们！你们想发家致富嘛？那就跟着钱布多老板教导的方法来，先去卖菜，然后去合作社办个证件养鸡，有点小钱了再去开开矿石和蚌壳吧，我们村走出去的钱布多老板就是这么一步步变成首富的。村民们要多多向他学习呀。",
//             days: 0,
//             type: 2,
//             headImgPath: "孙大妈",
//             signature: "孙大妈",
//             weight: 50,
//             chooseArray: [

//                 {
//                     chooseStr: "太厉害了",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2008,
//             title: "乾坤村村委会",
//             desc: "据说村口的池塘经常发出奇怪的响声，最近经常有村民在钓鱼的时候神秘失踪。还有人在池塘捞出了神秘的蛋，请各位发现特殊情况的村民请及时向村委会汇报情况。",
//             days: 0,
//             type: 2,
//             headImgPath: "孙大妈",
//             signature: "孙大妈",
//             weight: 50,
//             chooseArray: [

//                 {
//                     chooseStr: "什么情况？",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2009,
//             title: "重金寻子",
//             desc: "我是钱布多，是龙王矿业集团的老板，想必大家都认识我，许多年前的一个雨夜，我因逼不得已将我家族长子遗弃在村内养鸡场中，现出一千亿重金寻子。有线索者请速速联系我。此外还有重赏。",
//             days: 0,
//             type: 2,
//             headImgPath: "钱布多",
//             signature: "钱布多",
//             weight: 30,
//             chooseArray: [

//                 {
//                     chooseStr: "假的吧",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2010,
//             title: "遗书",
//             desc: "当你看到这个消息的时候，我很可能是嗝屁了，当年我就不应该收养那个孩子。连累我们小两口都被诅咒得了重病，但是为了恩人，我也认了。",
//             days: 20,
//             type: 2,
//             headImgPath: "爸",
//             signature: "爸",
//             weight: 50,
//             chooseArray: [

//                 {
//                     chooseStr: "确认",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },

//         {
//             uniqueId: 2011,
//             title: "借款广告",
//             desc: "您是否因为没钱而焦虑呢，那就选择我们飞秒借平台吧",
//             days: 0,
//             type: 2,
//             headImgPath: "银行经理",
//             signature: "银行经理",
//             weight: 50,
//             chooseArray: [

//                 {
//                     chooseStr: "联系",
//                     type: 2,
//                     onlyFlag: true,
//                     effectNums: 36,
//                 },
//                 {
//                     chooseStr: "扔回去",
//                     type: 3,
//                     onlyFlag: true,
//                     effectNums: 0,
//                 },
//             ],
//         },


















//         //事件类
//         {
//             uniqueId: 10001,
//             title: "意外收获",
//             desc: "你捞起了一个小保险箱，上面好像还有密码锁.",
//             days: 0,
//             type: 1,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "确认",
//                     type: 5,
//                     onlyFlag: true,
//                     effectNums: 10002,
//                 },
//             ]
//         },
//         {
//             uniqueId: 10002,
//             title: "意外收获",
//             desc: "你捞上来一张写满神秘数字的纸条，上面写着2023，你想起来之前捞到了一个盒子，你用密码打开了盒子！获得了一万元的奖励！",
//             days: -1,
//             type: 1,
//             weight: 50,
//             chooseArray: [
//                 {
//                     chooseStr: "打开盒子",
//                     type: 6,
//                     onlyFlag: true,
//                     effectNums: 10000,
//                 },
//             ]
//         },

        //物品的配置
        // {
        //     uniqueId : 100001,
        //     title : "太古灵石",
        //     desc : "居然是蕴藏上古神秘力量的奇迹灵石，赶紧收起来吧！",
        //     days : 0,
        //     type:5,
        //     weight : 10000,
        //     // goodsType : 1,
        //     // goodsImgPath : "lobster",
        //     imgPath:"ore/太古灵石" ,
        //     chooseArray : [
        //         {
        //             chooseStr : "收入背包",
        //             type : 4,
        //             effectNums : 300001,
        //             extraParamsMap : {
        //                 "10390"	:"50",
        //             },
        //         },
        //     ]
        // },


        //特殊事件的配置
        // {
        //     uniqueId : 100001,
        //     title : "特殊测试测试测试啊",
        //     desc : "居然是蕴藏上古神秘力量的奇迹灵石，赶紧收起来吧！",
        //     days : 0,
        //     type:6,
        //     weight : 10000,
        //     chooseArray : [
        //         {
        //             chooseStr : "知道了",
        //             type : 3,
        //             effectNums : 0,
        //         },
        //     ]
        // },
    ];
    return dataList;
}

/**
 * 漂流瓶配置
 */
export interface DriftBattleEntity {
    uniqueId : number;//唯一id
    title ?: string;//标题
    desc : string;//描述内容
    type : number;//类型  1 信息告知，2 事件任务告知 3 彩票 4 期货
    imgPath ?: string;//图片
    headImgPath ?: string;//头像

    goodsType ?: number;//物品类型
    goodsImgPath ?: string;//物品路径

    signature ?: string;//署名
    days : number;//天数触发 （ 0 默认加载 ，天数触发 ）
    weight : number;//权重

    //选项信息
    chooseArray : DriftChooseEntity[];
}

/**
 * 漂流选项实体
 */
export interface DriftChooseEntity {
    chooseStr : string;//选择内容
    type : number;//类型 1 缓存模块，2 聊天，3 信息告知，4 物品，5 后置事件注册 ,6 金币
    onlyFlag ?: boolean ;//唯一性
    effectNums : number;//影响数值
    extraParamsMap ?: ExtraParamsMap;
}

export interface ExtraParamsMap{
    [ key : string] : string ;
}
